export default "__VITE_ASSET__BZ94TLw1__"